const TAG_NAME = 'shopify-planner-helper';

if (!window.customElements.get(TAG_NAME)) {
    class ShopifyPlannerHelper extends HTMLElement {
        constructor() {
            super();

            this._setupListeners();
            this._init();
        }

        _init() {
            const frameUrl = new URL('https://konfigurator.nydo-studio.de'); // CHANGE THIS
            const searchParams = new URL(window.location).searchParams;
            const config = searchParams.get('config');

            if (config) {
                frameUrl.searchParams.append('config', config);
            }

            const family = searchParams.get('family');

            if (family) {
                frameUrl.searchParams.append('family', family);
            }

            frameUrl.searchParams.append('iframe', '1');

            this._setFrameUrl(frameUrl.toString());
        }

        _setFrameUrl(url) {
            const frame = this.querySelector('iframe');

            if (!frame) {
                return;
            }

            frame.src = url;
        }

        _setupListeners() {
            window.addEventListener('message', this._onMessageEvent.bind(this));
        }

        _onMessageEvent(event) {
            if (!event.data?.type) {
                return;
            }

            switch (event.data.type) {
                case 'cart:submit':
                    return this._onCartSubmit(event);
            }
        }

        async _onCartSubmit(event) {
            try {
                const items = event.data.detail.items.map(item => this._toIdQtySet(item, event.data.detail.configuration));

                await this._addToCart(items);
            } catch (error) {
                console.error('[Planner] Add to cart failed:', error);
                alert(error.message);
                return;
            }

            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true, // lets the event travel up to `document`
                composed: true, // allows crossing shadow DOM if needed
                detail: { baseEvent: 'variant:add', open: true }
            }));

            document.querySelector('cart-drawer')?.show();
            
            // PubSub: updates <cart-count> immediately (even if drawer is closed)
            const cart = await fetch(`${FoxTheme.routes.cart_url}.js`, { credentials: 'same-origin' }).then(r => r.json());
            if(cart) {
                FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                sources: 'cart-submit',
                cart
                });
            }
        }

        _getLocaleAwareUrlRoot(path = '') {
            return window?.Shopify?.routes?.root + path;
        }

        async _addToCart(items) {
            const response = await fetch(this._getLocaleAwareUrlRoot('cart/add.js'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ items })
            });
            const data = await response.json();

            // Shopify returns 422 with { description } e.g. variant not available in this market / sold out
            if (!response.ok) {
                throw new Error(data.description || data.message || 'Could not add items to cart');
            }

            return data;
        }

        _toIdQtySet(item, configuration) {
            if (!item.variant_id) {
                throw new Error('variant_id not found: Planner is most likely not using ShopifyCheckout or a product is missing a variant_id.');
            }

            return {
                id: item.variant_id,
                quantity: item.quantity,
                properties: {
                    _planner_code: configuration.code // IMPORTANT FOR ORDER CONVERSION TRACKING
                }
            }
        }
    }

    window.customElements.define(TAG_NAME, ShopifyPlannerHelper);
}
